$(document).ready(function(){
	
	// -- Slider Home --
	// ------------------
	var sliderHome = $('.slider--home');
	var sliderHomeSettings = {
		autoplay: true,
		autoplaySpeed: 6000,
		infinite: false,
		arrows: false,
		dots: false,
		fade: true
	};

	// -- Init --
	sliderHome.slick(sliderHomeSettings);

	// -- Dots Event --
	sliderHome.find('.btn--dot').on('click', function(event){
		var slideIndex = $(this).attr('data-index');
		sliderHome.slick('slickGoTo', slideIndex);
	});



	// -- Slider Gallery --
	// --------------------
	var sliderGallery = $('.slider--gallery');

	// -- Init --
	reloadSlickGallery(sliderGallery, sliderGallerySettings);

});



// -- GLOBAL FUNCTION BECAUSE OF AJAX CALL --
// ------------------------------------------

var sliderGallerySettings = {
	slidesToShow: 4,
	infinite: false,
	arrows: true,
	dots: false,
  responsive: [{
    breakpoint: 1092,
    settings: {
      slidesToShow: 2
    }
  },{
    breakpoint: 768,
    settings: {
      slidesToShow: 1
    }
  }]
};

function checkArrowNavClass(slide, button){
  if (slide.hasClass('slick-disabled')) {
  	button.addClass('arrowNav--disabled');
  } else {
  	button.removeClass('arrowNav--disabled');
  }
}

function checkArrowsNav(currentSlide){
  var prevSlide = currentSlide.$prevArrow;
  var nextSlide = currentSlide.$nextArrow;
  var prevBtn = $('.slider--gallery__arrowsNav .arrowNav--prev');
  var nextBtn = $('.slider--gallery__arrowsNav .arrowNav--next');
  checkArrowNavClass(prevSlide, prevBtn);
  checkArrowNavClass(nextSlide, nextBtn);
}

function reloadSlickGallery(sliderGallery, sliderGallerySettings){
	// -- Init --
	sliderGallery.on('init reInit', function(slick, currentSlide){
		checkArrowsNav(currentSlide);
	});
	sliderGallery.slick(sliderGallerySettings);

	// -- Arrows Event --
	$('.slider--gallery__arrowsNav .arrowNav--prev').on('click', function(){
		sliderGallery.slick('slickPrev');
	});
	$('.slider--gallery__arrowsNav .arrowNav--next').on('click', function(){
		sliderGallery.slick('slickNext');
	});
	sliderGallery.on('afterChange', function(slick, currentSlide){
		checkArrowsNav(currentSlide);
	});
}